// extracted by mini-css-extract-plugin
export var banner = "_o7-0";
export var settingRow = "_o7-2";
export var titleIcon = "_o7-1";